import keyMirror from 'keymirror'

export default keyMirror({
  GET_SERVICE_CENTER_ADMINS_REQUEST: null,
  GET_SERVICE_CENTER_ADMINS_SUCCESS: null,
  GET_SERVICE_CENTER_ADMINS_FAILED: null,

  GET_SERVICE_CENTER_ADMIN_REQUEST: null,
  GET_SERVICE_CENTER_ADMIN_SUCCESS: null,
  GET_SERVICE_CENTER_ADMIN_FAILED: null,

  GET_SERVICE_CENTER_ADMIN_DETAIL_REQUEST: null,
  GET_SERVICE_CENTER_ADMIN_DETAIL_SUCCESS: null,
  GET_SERVICE_CENTER_ADMIN_DETAIL_FAILED: null,

  GET_SERVICE_CENTER_ADMIN_PORTAL_ROLE_REQUEST: null,
  GET_SERVICE_CENTER_ADMIN_PORTAL_ROLE_SUCCESS: null,
  GET_SERVICE_CENTER_ADMIN_PORTAL_ROLE_FAILED: null,

  ADD_SERVICE_CENTER_ADMIN_REQUEST: null,
  ADD_SERVICE_CENTER_ADMIN_SUCCESS: null,
  ADD_SERVICE_CENTER_ADMIN_FAILED: null,

  DELETE_SERVICE_CENTER_ADMIN_REQUEST: null,
  DELETE_SERVICE_CENTER_ADMIN_SUCCESS: null,
  DELETE_SERVICE_CENTER_ADMIN_FAILED: null,

  RESEND_INVITATION_SERVICE_CENTER_REQUEST: null,
  RESEND_INVITATION_SERVICE_CENTER_SUCCESS: null,
  RESEND_INVITATION_SERVICE_CENTER_FAILED: null,

  UPDATE_FILTER_SERVICE_CENTER_ADMIN_SUCCESS: null,
  CLEAR_FILTER_SERVICE_CENTER_ADMIN_SUCCESS: null,

  GET_COMPANY_ROLE_CONFIGURATION_BY_COMPANY_ID_REQUEST: null,
  GET_COMPANY_ROLE_CONFIGURATION_BY_COMPANY_ID_SUCCESS: null,
  GET_COMPANY_ROLE_CONFIGURATION_BY_COMPANY_ID_FAILED: null,

  UPDATE_SERVICE_CENTER_ADMIN_ROLE_REQUEST: null,
  UPDATE_SERVICE_CENTER_ADMIN_ROLE_SUCCESS: null,
  UPDATE_SERVICE_CENTER_ADMIN_ROLE_FAILED: null
})
